// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__3-3CJ","spin":"Loader_spin__27HfD","BackDrop":"Loader_BackDrop__3R9Vo"};